import React from "react";

// Customizable Area Start
import { Box, Typography } from "@mui/material";
import { sideImage, logoImage } from "./assets";
import DOMPurify from 'dompurify';
import parse from 'html-react-parser';
// Customizable Area End

import TermsConditionsDetailController, {
  Props,
} from "./TermsConditionsDetailController";

export default class TermsConditionsDetail extends TermsConditionsDetailController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    return (
      <Box 
      sx={{ 
        height: '100vh',
        width: '100%',      
        display: 'flex',
        overflowX: 'hidden',
      }}>
        <Box 
        sx={{
          alignItems: 'flex-start',
          maxWidth: '50%',
          flex: 1,
          minWidth: 0,
          display: 'flex',
          padding: '32px 42px',         
          flexDirection: 'column',
          
        }}>
          <Box 
          sx={{ alignSelf: 'flex-start',  marginBottom: '32px',  }}>
            <img
            onClick={this.handleLogoClick} 
            style={{ height: '24px' , width: '148px', }}
            alt="Logo" 
              src={logoImage} 
              
            />
          </Box>

         <Box
         sx={{
          flexGrow: 1,
          overflowY: 'auto',
          pr: 2,
        }}
         >

            <Typography
              variant="h4"
              gutterBottom
              sx={{
                fontWeight: 600,
                mb: 2.5,
                fontSize: { xs: "1.5rem", md: "1.8rem" },
                mt: 3
              }}
            >
              Privacy Policy
            </Typography>

            <Typography
            data-test-id="privacy-content"
              variant="body1"
              sx={{
                lineHeight: 1.6,
                mb: { xs: 2, md: 3 },
                fontSize: { xs: "0.95rem", md: "1rem" },
                overflowWrap: 'break-word',
                wordBreak: 'break-word',
                
              }}
            >
              {parse(DOMPurify.sanitize(this.state.privacyPolicyContent))}
            </Typography>
          </Box>
          
        </Box>

        <Box sx={{
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '50%',
  position: 'relative'
}}>
  <img src={sideImage} alt="Background" style={{ width: '100%', height: '100%' }} />
  <Box sx={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0))`
  }} />
</Box>
      </Box>
    );
    // Customizable Area End
  }
}

// Customizable Area Start

// Customizable Area End
